import React from 'react'
import Form from 'react-bootstrap/Form'
import Slider from 'rc-slider'
import Select from 'react-select'

/**
 * This returns an Input component based on the NiTableAttributeType
 */
const Input = ({ type, handleInputChange, value, nwTblAttrType, name, attributes, uid }) => {
  const toggleOptions = {
    boolean: ['true', 'false'],
    password: ['present', 'not present']
  }

  switch (type) {
    case 'input_type_number': {
      return (
        <Form.Control
          type='number'
          value={value}
          onChange={(e) => { handleInputChange(e, null, uid) }}
          name={name}
        />
      )
    }
    case 'select_tag': {
      const options = toggleOptions[nwTblAttrType].map((val) => { return { label: val, value: val } })

      return (
        <Select
          isMulti
          defaultValue={value?.map((o) => { return { label: o, value: o } }) || []}
          name={name}
          options={options}
          onChange={(selectedOption) => {
            handleInputChange(
              {
                target: {
                  type: 'multiselect',
                  value: selectedOption.map((o) => { return o.value })
                }
              },
              null,
              uid
            )
          }}
        />
      )
    }

    case 'input_type_range': {
      const defaults = Object.freeze({ min: 0, max: 100, step: 1 })
      const getMin = val => +val || defaults.min
      const getMax = val => +val || defaults.max
      const getStep = val => +val || defaults.step
      const getVal = val => val || [+attributes.min || defaults.min, +attributes.max || defaults.max]
      const marks = {}
      marks[getMin()] = getMin()
      marks[getMax()] = getMax()

      return (
        <div className='range-input mx-4 d-flex flex-column align-items-center'>
          <Slider
            range
            defaultValue={getVal(value)}
            marks={marks}
            allowCross={false}
            onAfterChange={(num) => { handleInputChange({ target: { type: 'range' } }, num, uid) }}
            name={name}
            min={getMin(attributes.min)}
            max={getMax(attributes.max)}
            step={getStep(attributes.step)}
            aria-labelledby='range-slider'
          />
          <div>
            {getVal(value)[0]} to {getVal(value)[1]}
          </div>
        </div>
      )
    }
    case 'input_type_color': {
      return (
        <Form.Control
          type='color'
          id='standard-color'
          onChange={(e) => { handleInputChange(e, null, uid) }}
          name={name}
          value={value}
        />
      )
    }
    case 'input_type_date': {
      return (
        <Form.Control
          id='standard-number'
          type='date'
          value={value}
          onChange={(e) => { handleInputChange(e, null, uid) }}
          name={name}
        />
      )
    }

    case 'input_type_radio': {
      return (
        <div className='mx-2'>
          {
            toggleOptions[nwTblAttrType].map((val, idx) => (
              <Form.Check
                inline
                key={idx}
                id={`inline-radio-${name}-${idx}`}
                value={val}
                name={name}
                label={val.toString().charAt(0).toUpperCase() + val.toString().slice(1)}
                type='radio'
                checked={value === val.toString()}
                onChange={(e) => { handleInputChange(e, null, uid) }}
              />
            ))
          }
        </div>
      )
    }
    case 'input_type_checkbox': {
      // only supported for type boolean for now
      return (
        <div className='mx-2'>
          {
            toggleOptions[nwTblAttrType].map((val, idx) => (
              <Form.Check
                inline
                key={idx}
                id={`inline-checkbox-${name}-${idx}`}
                value={val}
                name={name}
                label={val.toString().charAt(0).toUpperCase() + val.toString().slice(1)}
                type='checkbox'
                checked={value && value.includes(val.toString())}
                onChange={(e) => { handleInputChange(e, null, uid) }}
              />
            ))
          }
        </div>
      )
    }
    case 'input_type_time': {
      return (
        <Form.Control
          id='datetime-local'
          type='datetime-local'
          name={name}
          value={value}
          onChange={(e) => { handleInputChange(e, null, uid) }}
        />
      )
    }
  }
}

export default Input
